import React from "react";
import { Col, Input, Label } from "reactstrap";
import {
  SHARE_EXPIRY_UNITS,
  type ShareExpiryUnit,
} from "./shareLinkExpiry";

type ShareLinkExpiryFieldsProps = {
  amount: number;
  unit: ShareExpiryUnit;
  onAmountChange: (value: number) => void;
  onUnitChange: (unit: ShareExpiryUnit) => void;
  amountId?: string;
  unitId?: string;
};

const ShareLinkExpiryFields: React.FC<ShareLinkExpiryFieldsProps> = ({
  amount,
  unit,
  onAmountChange,
  onUnitChange,
  amountId = "share-expiry-amount",
  unitId = "share-expiry-unit",
}) => {
  return (
    <>
      <Col md={3} sm={6}>
        <Label className="fw-bold" for={amountId}>
          Expires in
        </Label>
        <Input
          id={amountId}
          type="number"
          min={1}
          step={1}
          value={Number.isFinite(amount) && amount > 0 ? amount : ""}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === "") {
              onAmountChange(0);
              return;
            }
            const n = Math.floor(Number(raw));
            onAmountChange(Number.isFinite(n) ? n : 0);
          }}
        />
      </Col>
      <Col md={3} sm={6}>
        <Label className="fw-bold" for={unitId}>
          Unit
        </Label>
        <Input
          id={unitId}
          type="select"
          value={unit}
          onChange={(e) => onUnitChange(e.target.value as ShareExpiryUnit)}
        >
          {SHARE_EXPIRY_UNITS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      </Col>
    </>
  );
};

export default ShareLinkExpiryFields;
